const EMAIL_INQUIRIES_DEV = 'Fn2171069.Ln2171069@qa.ampf.com'
const EMAIL_LEARNING_CENTER_PROD = 'learning.center@columbiathreadneedle.com'
const EMAIL_SALES_PROD = 'salesinquiries@columbiathreadneedle.com'
export const EMAIL_FUTURE_SCHOLAR_PROD = 'future_scholar_529_csp@sscinc.com'
export const EMAIL_SERVICE_PROD = 'columbiaserviceinquiries@sscinc.com'

export const getSSOInternalLoginPostUrl = (userId) => {
  const dev = `https://wam.dev.advisorcompass.com/aciam/app/autoPopulateUserID?userId=${userId}`
  const qa = `https://wam.qa.advisorcompass.com/aciam/app/autoPopulateUserID?userId=${userId}`
  const prod = `https://wam.advisorcompass.com/aciam/app/autoPopulateUserID?userId=${userId}`
  const qaAgentB = `https://wam.advisorcompass.com/aciam/app/autoPopulateUserID?userId=${userId}&target=https://wam.qa.advisorcompass.com/ac/ctnb`
  const qaAgentC = `https://wam.qa.advisorcompass.com/aciam/app/autoPopulateUserID?userId=${userId}&target=https://wam.qa.advisorcompass.com/ac/ctnb`
  const qaAgentD = `https://wam.qa.advisorcompass.com/aciam/app/autoPopulateUserID?userId=${userId}&target=https://wam.qa.advisorcompass.com/ac/ctnbp`

  let url

  const hostname = window.location.hostname

  switch (hostname) {
    case 'www-preprod.columbiathreadneedleus.com':
      url = qaAgentB
      break
    case 'www-ws3.qa.columbiathreadneedleus.com':
      url = qaAgentC
      break
    case 'perf-ws1.qa.columbiathreadneedleus.com':
      url = qaAgentD
      break
    case 'localhost':
      url = qa
      break
    case 'www.dev.columbiathreadneedleus.com':
    case 'www.qa.stage.com':
      url = dev
      break
    case 'www.qa.columbiathreadneedleus.com':
      url = qa
      break
    default:
      url = prod
      break
  }

  return url
}

export const getAdvisorCompassUrl = () => {
  const dev = 'https://www-01.dev.advisorcompass.com/web/advisorcompass'
  const qa = 'https://www.qa.advisorcompass.com/web/advisorcompass'
  const prod = 'https://www.advisorcompass.com/web/advisorcompass'

  //for local, use dev environment
  return getUrlForCurrentEnvironment(dev, dev, qa, prod)
}

export const getClientId = () => {
  const dev = '2a7685bd-a77c-491f-9d81-deb0d22e882c'
  const qa = '8c1cf46c-20f7-4fce-90db-fc8918abd90b'
  const prod = '0d04fbf3-5f8e-4525-928a-9c296a2ec7b0'

  return getUrlForCurrentEnvironment(qa, dev, qa, prod)
}

/**
 * LOL, lets see if veracode catches this
 */
export const getClientSecret = () => {
  const dev = '61c7eea4-444f-4fef-9e7e-bd4c95fd1737'
  const qa = '5b3a2a3d-95ea-492c-9fff-3ae7f01b1ec2'
  const prod = '805dac6c-6ee1-46e2-822c-381d1efdc34b'

  return getUrlForCurrentEnvironment(qa, dev, qa, prod)
}

export const getApiTokenUrl = () => {
  const dev = 'https://api.wam.dev.ameriprise.com/cl/v1/api/token'
  const qa = 'https://api.wam.qa.ameriprise.com/cl/v1/api/token'
  const prod = 'https://api.wam.ameriprise.com/cl/v1/api/token'

  return getUrlForCurrentEnvironment(qa, dev, qa, prod)
}

export const getWamLoginUrl = () => {
  const dev = 'https://api.wam.dev.ameriprise.com/cl/v1/user/session'
  const qa = 'https://api.wam.qa.ameriprise.com/cl/v1/user/session'
  const prod = 'https://api.wam.ameriprise.com/cl/v1/user/session'

  return getUrlForCurrentEnvironment(qa, dev, qa, prod)
}

export const getBaseWamUrl = () => {
  const dev = 'https://api.wam.dev.ameriprise.com'
  const qa = 'https://api.wam.qa.ameriprise.com'
  const prod = 'https://api.wam.ameriprise.com'

  return getUrlForCurrentEnvironment(qa, dev, qa, prod)
}

export function getLongTermCookieOptions() {
  // set the cookie to expire in 40 years.
  // why 40 years, lets see what browser can last longer than 40 years without having its history wiped
  // is this safe from 2038 unix time bug? :P
  const yearsToExpireCookie = 40
  const days = 365 * yearsToExpireCookie

  const local = { expires: days, path: '/' }
  const dev = {
    expires: days,
    path: '/',
    domain: '.columbiathreadneedleus.com',
  }
  const qa = { expires: days, path: '/', domain: '.columbiathreadneedleus.com' }
  const prod = {
    expires: days,
    path: '/',
    domain: '.columbiathreadneedleus.com',
  }

  return getUrlForCurrentEnvironment(local, dev, qa, prod)
}

/* Happy path for local dev: Fn2171069.Ln2171069@qa.ampf.com */
export const getEmailLearningCenter = () => {
  const local = EMAIL_INQUIRIES_DEV
  const dev = EMAIL_INQUIRIES_DEV
  const qa = EMAIL_INQUIRIES_DEV
  const prod = EMAIL_LEARNING_CENTER_PROD
  return getUrlForCurrentEnvironment(local, dev, qa, prod)
}

export const getEmailServiceInquiries = () => {
  const local = EMAIL_SERVICE_PROD
  const dev = EMAIL_INQUIRIES_DEV
  const qa = EMAIL_SERVICE_PROD
  const prod = EMAIL_SERVICE_PROD
  return getUrlForCurrentEnvironment(local, dev, qa, prod)
}

export const getEmailSalesInquiries = () => {
  const local = EMAIL_INQUIRIES_DEV
  const dev = EMAIL_INQUIRIES_DEV
  const qa = EMAIL_INQUIRIES_DEV
  const prod = EMAIL_SALES_PROD
  return getUrlForCurrentEnvironment(local, dev, qa, prod)
}

export const getEmailFutureScholar = () => {
  const local = EMAIL_FUTURE_SCHOLAR_PROD
  const dev = EMAIL_INQUIRIES_DEV
  const qa = EMAIL_FUTURE_SCHOLAR_PROD
  const prod = EMAIL_FUTURE_SCHOLAR_PROD
  return getUrlForCurrentEnvironment(local, dev, qa, prod)
}

export function getInternalRedirectLoginUrl() {
  const dev = 'https://wam.dev.advisorcompass.com/ac/ctn/redirect'
  const qa = 'https://wam.qa.advisorcompass.com/ac/ctn/redirect'
  const prod = 'https://wam.advisorcompass.com/ac/ctn/redirect'

  return getUrlForCurrentEnvironment(dev, dev, qa, prod)
}

/**
 * Given urls for different environments, it returns the proper url
 *
 * @param local
 * @param dev
 * @param qa
 * @param prod
 * @returns {*}
 */
export const getUrlForCurrentEnvironment = (local, dev, qa, prod) => {
  let url = prod

  const hostname = window.location.hostname

  if (hostname.indexOf('localhost') >= 0) {
    url = local
  } else if (
    hostname.indexOf('.dev.columbiathreadneedleus') >= 0 ||
    hostname.indexOf('qa.stage.') >= 0
  ) {
    url = dev
  } else if (hostname.indexOf('.qa.columbiathreadneedleus') >= 0) {
    url = qa
  }

  return url
}
